var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMastercard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 12,
    viewBox: "0 0 20 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 6c0 3.314-2.91 6-6.5 6S0 9.314 0 6s2.91-6 6.5-6S13 2.686 13 6z",
    fill: "#E2574C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 0a6.821 6.821 0 0 0-3.883 1.196l.006.001c.213.19.448.324.63.543L8.9 1.76a6.329 6.329 0 0 0-.587.635h2.384c.181.201.349.376.5.598H7.882a5.821 5.821 0 0 0-.332.598h4.027c.106.206.2.361.28.579H7.311a5.424 5.424 0 0 0-.181.635h4.916c.049.207.086.4.11.595H7.034A5.554 5.554 0 0 0 7 6h5.194c0 .212-.016.41-.04.6H7.033c.022.203.054.403.097.6h4.909c-.051.194-.11.39-.183.593h-4.56c.069.205.153.404.244.599h4.036c-.111.218-.238.393-.378.597H7.87c.131.21.276.41.433.603l2.395.033c-.204.226-.466.362-.705.56.013.01-.381-.001-1.158-.013C10.016 11.298 11.668 12 13.5 12c3.59 0 6.5-2.686 6.5-6s-2.91-6-6.5-6z",
    fill: "#F4B459"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/Mastercard.d85496e6.svg";
export { ForwardRef as ReactComponent };